module.exports = __webpack_public_path__ + "static/media/22ESCWA23.d2f50480.jpg";